import React from 'react'
import styled from 'styled-components'
import { ThemeSpace } from 'theme/spaces'

export interface CardGroupProps {
  children: React.ReactNode[] | React.ReactNode
  minWidth?: ThemeSpace
  gridGap?: ThemeSpace
}

export const CardContainer = styled.div<{
  $minWidth: ThemeSpace
  $gridGap: ThemeSpace
}>`
  display: grid;
  align-items: start;
  padding-top: ${({ theme }) => theme.space.s24};

  grid-gap: ${({ theme, $gridGap }) => theme.space[$gridGap]};
  grid-template-columns: repeat(
    auto-fill,
    minmax(
      ${({ theme, $minWidth }) =>
        $minWidth ? theme.space[$minWidth] : theme.space.s240},
      1fr
    )
  );

  ${({ theme }) => theme.mediaQuery.phone} {
    grid-template-columns: repeat(
      auto-fill,
      minmax(${({ theme }) => theme.space.s240}, 1fr)
    );
  }
`

export const CardGroup: React.FC<CardGroupProps> = ({
  children,
  minWidth = 's240',
  gridGap = 's24',
}) => {
  return (
    <CardContainer $gridGap={gridGap} $minWidth={minWidth}>
      {children}
    </CardContainer>
  )
}
